// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { boolean, number, nullOrUndefined, string } from "@altostra/type-validations/lib/primitives";

export const isEngagementPredictionStatsPredictionIdResult = objectOf({
  success: boolean,
  update_time: number,
  training_data: objectOf({
    base_rate: number,
    cumulative_rate: arrayOf(number),
    lift_quality: number,
    log_loss: number,
    model_feature_stats: objectOf({
      median: number,
      mean: number,
      max: number,
      min: number,
      std: number,
    }),
    model_features: objectOf({
      created_at: number,
      attribute_count: number,
      campaign_summary_tbeds_1: number,
      campaign_summary_tbeds_4: number,
      campaign_summary_tbeds_16: number,
      campaign_summary_tbeds_64: number,
      event_tbeds_1: number,
      event_tbeds_4: number,
      event_tbeds_16: number,
      event_tbeds_64: number,
      money_spent_tbeds_1: number,
      money_spent_tbeds_4: number,
      money_spent_tbeds_16: number,
      money_spent_tbeds_64: number,
      session_tbeds_1: number,
      session_tbeds_4: number,
      session_tbeds_16: number,
      session_tbeds_64: number,
      platform: number,
    }),
    overpredict: number,
    score_percentiles: arrayOf(number),
    success: boolean,
    target_size: number,
    test_label_size: number,
    train_size: number,
    train_target_size: number,
    leaker_custom_params: objectOf({
      exclude_campaign_tbeds: number,
    }),
    feature_distributions: objectOf({
      created_at: objectOf({
        count: number,
        mean: number,
        std: number,
        min: number,
        "5%": number,
        "25%": number,
        "50%": number,
        "75%": number,
        "95%": number,
        max: number,
      }),
      attribute_count: objectOf({
        count: number,
        mean: number,
        std: number,
        min: number,
        "5%": number,
        "25%": number,
        "50%": number,
        "75%": number,
        "95%": number,
        max: number,
      }),
      platform: objectOf({
        count: number,
        mean: number,
        std: number,
        min: number,
        "5%": number,
        "25%": number,
        "50%": number,
        "75%": number,
        "95%": number,
        max: number,
      }),
      churn: objectOf({
        count: number,
        mean: number,
        std: number,
        min: number,
        "5%": number,
        "25%": number,
        "50%": number,
        "75%": number,
        "95%": number,
        max: number,
      }),
      campaign_summary_tbeds_1: objectOf({
        count: number,
        mean: number,
        std: number,
        min: number,
        "5%": number,
        "25%": number,
        "50%": number,
        "75%": number,
        "95%": number,
        max: number,
      }),
      campaign_summary_tbeds_4: objectOf({
        count: number,
        mean: number,
        std: number,
        min: number,
        "5%": number,
        "25%": number,
        "50%": number,
        "75%": number,
        "95%": number,
        max: number,
      }),
      campaign_summary_tbeds_16: objectOf({
        count: number,
        mean: number,
        std: number,
        min: number,
        "5%": number,
        "25%": number,
        "50%": number,
        "75%": number,
        "95%": number,
        max: number,
      }),
      campaign_summary_tbeds_64: objectOf({
        count: number,
        mean: number,
        std: number,
        min: number,
        "5%": number,
        "25%": number,
        "50%": number,
        "75%": number,
        "95%": number,
        max: number,
      }),
      event_tbeds_1: objectOf({
        count: number,
        mean: number,
        std: number,
        min: number,
        "5%": number,
        "25%": number,
        "50%": number,
        "75%": number,
        "95%": number,
        max: number,
      }),
      event_tbeds_4: objectOf({
        count: number,
        mean: number,
        std: number,
        min: number,
        "5%": number,
        "25%": number,
        "50%": number,
        "75%": number,
        "95%": number,
        max: number,
      }),
      event_tbeds_16: objectOf({
        count: number,
        mean: number,
        std: number,
        min: number,
        "5%": number,
        "25%": number,
        "50%": number,
        "75%": number,
        "95%": number,
        max: number,
      }),
      event_tbeds_64: objectOf({
        count: number,
        mean: number,
        std: number,
        min: number,
        "5%": number,
        "25%": number,
        "50%": number,
        "75%": number,
        "95%": number,
        max: number,
      }),
      money_spent_tbeds_1: objectOf({
        count: number,
        mean: number,
        std: number,
        min: number,
        "5%": number,
        "25%": number,
        "50%": number,
        "75%": number,
        "95%": number,
        max: number,
      }),
      money_spent_tbeds_4: objectOf({
        count: number,
        mean: number,
        std: number,
        min: number,
        "5%": number,
        "25%": number,
        "50%": number,
        "75%": number,
        "95%": number,
        max: number,
      }),
      money_spent_tbeds_16: objectOf({
        count: number,
        mean: number,
        std: number,
        min: number,
        "5%": number,
        "25%": number,
        "50%": number,
        "75%": number,
        "95%": number,
        max: number,
      }),
      money_spent_tbeds_64: objectOf({
        count: number,
        mean: number,
        std: number,
        min: number,
        "5%": number,
        "25%": number,
        "50%": number,
        "75%": number,
        "95%": number,
        max: number,
      }),
      session_tbeds_1: objectOf({
        count: number,
        mean: number,
        std: number,
        min: number,
        "5%": number,
        "25%": number,
        "50%": number,
        "75%": number,
        "95%": number,
        max: number,
      }),
      session_tbeds_4: objectOf({
        count: number,
        mean: number,
        std: number,
        min: number,
        "5%": number,
        "25%": number,
        "50%": number,
        "75%": number,
        "95%": number,
        max: number,
      }),
      session_tbeds_16: objectOf({
        count: number,
        mean: number,
        std: number,
        min: number,
        "5%": number,
        "25%": number,
        "50%": number,
        "75%": number,
        "95%": number,
        max: number,
      }),
      session_tbeds_64: objectOf({
        count: number,
        mean: number,
        std: number,
        min: number,
        "5%": number,
        "25%": number,
        "50%": number,
        "75%": number,
        "95%": number,
        max: number,
      }),
    }),
    model_params: objectOf({}),
  }),
  validation_data: objectOf({}),
  correlation_data: arrayOf(nullOrUndefined),
  model_type: string,
  update_data: objectOf({
    percent_distribution: arrayOf(
      objectOf({
        x: number,
        y: number,
      })
    ),
    target_score_by_top_total: arrayOf(number),
    total_users: number,
    estimated_target_users_count: number,
  }),
});
